import { PRIORITY_COLLECTIONS } from '../../constants/tabConfig';
export const collectionInfoLookup = ({ bucketsContent }) =>
    bucketsContent.map(
        ({
            imageLarge,
            name,
            eventCount,
            id,
            displayCreatorName,
            creator,
            summary,
            creatorImageIdOverrideUrl,
        }) => ({
            imageLarge,
            name,
            eventCount,
            id,
            displayCreatorName,
            creator,
            summary,
            creatorImageIdOverrideUrl,
        }),
    );

export const orderCollections = ({ collections }) => {
    if (
        collections &&
        typeof collections === 'object' &&
        !Array.isArray(collections)
    ) {
        let orderedCollections = {};
        PRIORITY_COLLECTIONS.forEach((key) => {
            if (key in collections && !(key in orderedCollections)) {
                orderedCollections[key] = collections[key];
            }
        });
        orderedCollections = { ...orderedCollections, ...collections };

        return orderedCollections;
    } else {
        return collections;
    }
};
